import { defaultProps, withHandlers, compose } from 'recompose';

export default compose(
	defaultProps({ percentVisible: 70 }),
	withHandlers({
		onVisible: ({ onVisible, facility, percentVisible }) => (delay) => {
			onVisible({
				facility_id: facility.id,
				visible_threshold: percentVisible,
				index: facility.index,
				rank: facility.position,
				in_network: facility.inNetwork,
				delay
			});
		}
	})
);
